import { render } from "./CategoriesView.vue?vue&type=template&id=73d20fe4&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"

import "./CategoriesView.vue?vue&type=style&index=0&id=73d20fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d20fe4"]])

export default __exports__